const topViewPaper = Raphael(
  "top-view",
  document.getElementById("top-view").offsetWidth,
  document.getElementById("top-view").offsetHeight)
const sideViewPaper = Raphael(
  "side-view", 
  document.getElementById("side-view").offsetWidth, 
  document.getElementById("side-view").offsetHeight)

const oneWayShearPaper = Raphael(
    "one-way-shear-diagram", 
    document.getElementById("one-way-shear-diagram").offsetWidth, 
    document.getElementById("one-way-shear-diagram").offsetHeight)

const twoWayShearPaper = Raphael(
  "two-way-shear-diagram", 
  document.getElementById("two-way-shear-diagram").offsetWidth, 
  document.getElementById("two-way-shear-diagram").offsetHeight)

const flexurePaper = Raphael(
  "flexure-diagram", 
  document.getElementById("flexure-diagram").offsetWidth, 
  document.getElementById("flexure-diagram").offsetHeight)

const bearingLoadPaper = Raphael(
  "bearing-load-diagram", 
  document.getElementById("bearing-load-diagram").offsetWidth, 
  document.getElementById("bearing-load-diagram").offsetHeight)

export async function drawAllDiagrams(footing) {
  drawFootingTopView(footing)
  drawFootingSideView(footing)
  drawOneWayShearDiagram(footing)
  drawTwoWayShearDiagram(footing)
  drawFlexureDiagram(footing)
  drawBearingLoadDiagram(footing)
}

export async function drawFootingTopView(footing) {
  const paper = topViewPaper

  paper.clear()

  const canvasW = document.getElementById("top-view").offsetWidth
  const canvasH = document.getElementById("top-view").offsetHeight
  const canvasRect = [canvasW, canvasH]
  
  const footingWidth = footing.geometry.footingWidth
  const footingThickness = footing.geometry.footingThickness
  const footingHeight = footingWidth
  const scale1 = getScale(footingWidth, footingHeight, canvasRect)
  const scale2 = getScale(footingWidth, footingThickness * 1.5, canvasRect)
  const scale = Math.min(scale1, scale2)
  
  const st = paper.set()

  drawSquareFootingTopView(footing, scale, paper, st) 

  drawColumnTopView(footing, scale, paper, st)

  drawTopViewColumnToEdgeDimensions(footing, scale, paper, st)

  const center = [canvasRect[0] * 0.5, canvasRect[1] * 0.5]
  const blockLeftEdge = center[0] - footingWidth * scale * 0.5
  const blockTopEdge = center[1] - footingHeight * scale * 0.5

  st.translate(blockLeftEdge, blockTopEdge)
}

export async function drawFootingSideView(footing) {
  const paper = sideViewPaper

  paper.clear()

  const canvasW = document.getElementById("bearing-load-diagram").offsetWidth
  const canvasH = document.getElementById("bearing-load-diagram").offsetHeight
  const canvasRect = [canvasW, canvasH]
  
  const footingWidth = footing.geometry.footingWidth
  const footingThickness = footing.geometry.footingThickness
  const footingHeight = footingWidth
  const columnWidth = footing.geometry.columnWidth
  const scale1 = getScale(footingWidth, footingHeight, canvasRect)
  const scale2 = getScale(footingWidth, footingThickness * 1.5, canvasRect)
  const scale = Math.min(scale1, scale2)
  
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5
  
  const st = paper.set()

  drawSquareFootingSideView(footing, scale, paper, st)

  drawSideViewFloorAndFill(footing, scale, paper, st)

  drawSideViewSteel(footing, scale, paper, st)

  // draw floor load
  if(Math.abs(footing.load.floorLoad) > 0) {
    let yOffset = 0
    if(footing.load.fillDepth > 0) {
      yOffset += footing.load.fillDepth
    }
    if(footing.load.floorSlabThickness > 0) {
      yOffset += footing.load.floorSlabThickness
    }
    let x = columnStart + columnWidth + 6
    let y = footingHeight - footingThickness - yOffset 
    let nArrows = 2
    let delta = (footingWidth * 0.5 - columnWidth * 0.5) * 0.25 / nArrows
    for(let i = 0; i < nArrows + 1; i++) {
      st.push(drawDownLoadArrow(
        (x + i * delta) * scale, 
        y * scale - 40, 
        (x + i * delta) * scale, 
        y * scale, 10, paper).attr("stroke-width", 1))
    }

    // draw the label
    st.push(drawDiameterArrow((x + delta) * scale, y * scale - 42, 5, paper))
    st.push(drawLabelForDiameterDimension(`${footing.load.floorLoad} psf`, (x + delta) * scale, y * scale - 40, 5, 12, paper))
  }

  // draw column or wall distributed load arrows 
  const drawDistLoads = false
  if(drawDistLoads) {
    let nArrows = 5
    let delta = columnWidth / nArrows
    for(let i = 0; i < nArrows + 1; i++) {
      st.push(drawDownLoadArrow(
        columnStart * scale + i * delta * scale, 
        (footingHeight - footingThickness) * scale - 40, 
        columnStart * scale + i * delta * scale, 
        (footingHeight - footingThickness) * scale, 10, paper).attr("stroke-width", 2))
    }
  

    nArrows = 10
    delta = footingWidth / nArrows
    for(let i = 0; i < nArrows + 1; i++) {
      st.push(drawUpLoadArrow(
        i * delta * scale, 
        footingHeight * scale, 
        i * delta * scale, 
        footingHeight * scale + 20, 10, paper).attr("stroke-width", 2))
    }
  }

  const center = [canvasRect[0] * 0.5, canvasRect[1] * 0.5]
  const blockLeftEdge = center[0] - footingWidth * scale * 0.5
  const blockTopEdge = center[1] - footingHeight * scale * 0.5

  st.translate(blockLeftEdge, blockTopEdge)

}

export async function drawOneWayShearDiagram(footing) {
  const paper = oneWayShearPaper

  paper.clear()

  const canvasW = document.getElementById("one-way-shear-diagram").offsetWidth
  const canvasH = document.getElementById("one-way-shear-diagram").offsetHeight
  const canvasRect = [canvasW, canvasH]
  
  const footingWidth = footing.geometry.footingWidth
  const footingThickness = footing.geometry.footingThickness
  const footingHeight = footingWidth
  const scale1 = getScale(footingWidth, footingHeight, canvasRect)
  const scale2 = getScale(footingWidth, footingThickness * 1.5, canvasRect)
  const scale = Math.min(scale1, scale2)
  
  const st = paper.set()

  drawSquareFootingTopView(footing, scale, paper, st) 

  drawColumnTopView(footing, scale, paper, st)

  drawOneWayShearArea(footing, scale, paper, st)

  const center = [canvasRect[0] * 0.5, canvasRect[1] * 0.5]
  const blockLeftEdge = center[0] - footingWidth * scale * 0.5
  const blockTopEdge = center[1] - footingHeight * scale * 0.5

  st.translate(blockLeftEdge, blockTopEdge)
}

export async function drawTwoWayShearDiagram(footing) {
  const paper = twoWayShearPaper

  paper.clear()

  const canvasW = document.getElementById("two-way-shear-diagram").offsetWidth
  const canvasH = document.getElementById("two-way-shear-diagram").offsetHeight
  const canvasRect = [canvasW, canvasH]
  
  const footingWidth = footing.geometry.footingWidth
  const footingThickness = footing.geometry.footingThickness
  const footingHeight = footingWidth
  const scale1 = getScale(footingWidth, footingHeight, canvasRect)
  const scale2 = getScale(footingWidth, footingThickness * 1.5, canvasRect)
  const scale = Math.min(scale1, scale2)
  
  const st = paper.set()

  drawSquareFootingTopView(footing, scale, paper, st) 

  drawColumnTopView(footing, scale, paper, st)

  drawTwoWayShearArea(footing, scale, paper, st)

  const center = [canvasRect[0] * 0.5, canvasRect[1] * 0.5]
  const blockLeftEdge = center[0] - footingWidth * scale * 0.5
  const blockTopEdge = center[1] - footingHeight * scale * 0.5

  st.translate(blockLeftEdge, blockTopEdge)
}

export async function drawFlexureDiagram(footing) {
  const paper = flexurePaper

  paper.clear()

  const canvasW = document.getElementById("flexure-diagram").offsetWidth
  const canvasH = document.getElementById("flexure-diagram").offsetHeight
  const canvasRect = [canvasW, canvasH]
  
  const footingWidth = footing.geometry.footingWidth
  const footingThickness = footing.geometry.footingThickness
  const footingHeight = footingWidth
  const scale1 = getScale(footingWidth, footingHeight, canvasRect)
  const scale2 = getScale(footingWidth, footingThickness * 1.5, canvasRect)
  const scale = Math.min(scale1, scale2)
  
  const st = paper.set()

  drawSquareFootingTopView(footing, scale, paper, st) 

  drawColumnTopView(footing, scale, paper, st)

  drawFlexureArea(footing, scale, paper, st)

  const center = [canvasRect[0] * 0.5, canvasRect[1] * 0.5]
  const blockLeftEdge = center[0] - footingWidth * scale * 0.5
  const blockTopEdge = center[1] - footingHeight * scale * 0.5

  st.translate(blockLeftEdge, blockTopEdge)

}

export async function drawBearingLoadDiagram(footing) {
  const paper = bearingLoadPaper

  paper.clear()

  const canvasW = document.getElementById("bearing-load-diagram").offsetWidth
  const canvasH = document.getElementById("bearing-load-diagram").offsetHeight
  const canvasRect = [canvasW, canvasH]
  
  const footingWidth = footing.geometry.footingWidth
  const footingThickness = footing.geometry.footingThickness
  const footingHeight = footingWidth
  const scale1 = getScale(footingWidth, footingHeight, canvasRect)
  const scale2 = getScale(footingWidth, footingThickness * 1.5, canvasRect)
  const scale = Math.min(scale1, scale2)
  
  const st = paper.set()

  drawSquareFootingSideView(footing, scale, paper, st)

  drawSideViewShearCone(footing, scale, paper, st)

  const center = [canvasRect[0] * 0.5, canvasRect[1] * 0.5]
  const blockLeftEdge = center[0] - footingWidth * scale * 0.5
  const blockTopEdge = center[1] - footingHeight * scale * 0.5

  st.translate(blockLeftEdge, blockTopEdge)
    
}

function drawSquareFootingTopView(footing, scale, paper, drawingSet) {
  const footingWidth = footing.geometry.footingWidth
  const footingHeight = footingWidth

  drawingSet.push(paper.rect(0, 0, footingWidth * scale, footingHeight * scale).attr("stroke-width", 2))

  // width label
  let x1 = 0
  let y1 = footingHeight * scale + 14 
  let x2 = footingWidth * scale 
  let y2 = y1
  drawingSet.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  let str = `${footingWidth} in`  
  drawingSet.push(drawLabelForHorizontalDimension(str, x1, x2, y1, 12, paper))

  // height label
  x1 = -10
  y1 = 0
  x2 = x1
  y2 = footingHeight * scale  
  drawingSet.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${footingHeight} in`  
  drawingSet.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'left', 12, paper))

}

function drawColumnTopView(footing, scale, paper, drawingSet) {
  // draw the column or wall
  const footingWidth = footing.geometry.footingWidth
  const footingHeight = footing.geometry.footingWidth
  const columnWidth = footing.geometry.columnWidth
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5
  
  drawingSet.push(paper.rect(columnStart * scale, columnStart * scale, columnWidth * scale, columnWidth * scale).attr("stroke-width", 2))

  let x1 = columnStart * scale - 10
  let y1 = (footingHeight * 0.5 - columnWidth * 0.5) * scale
  let x2 = x1
  let y2 = (footingHeight * 0.5 + columnWidth * 0.5) * scale
  let str = `${columnWidth} in`  
  drawingSet.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
  drawingSet.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'left', 12, paper))

  x1 = columnStart * scale
  y1 = (footingHeight * 0.5 + columnWidth * 0.5) * scale + 10
  x2 = (columnStart + columnWidth) * scale
  y2 = y1
  str = `${columnWidth} in`  
  drawingSet.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  drawingSet.push(drawLabelForHorizontalDimension(str, x1, x2, y1, 12, paper))
}

function drawSquareFootingSideView(footing, scale, paper, drawingSet) {
  const footingWidth = footing.geometry.footingWidth
  const footingThickness = footing.geometry.footingThickness
  const footingHeight = footingWidth
  const columnWidth = footing.geometry.columnWidth
  
  //const st = paper.set()

  // draw the footing
  drawingSet.push(paper.rect(0, (footingHeight - footingThickness) * scale, footingWidth * scale, footingThickness * scale).attr("stroke-width", 2))

  // draw the column or wall
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5
  const columnHeight = footingHeight - footingThickness

  let pathStr = pathM( columnStart * scale, 0)
  pathStr += pathL( columnStart * scale, columnHeight * scale)
  let p = paper.path(pathStr)
  drawingSet.push(p.attr("stroke-width", 2))

  pathStr = pathM( (columnStart + columnWidth) * scale, 0)
  pathStr += pathL( (columnStart + columnWidth) * scale, columnHeight * scale)
  p = paper.path(pathStr)
  drawingSet.push(p.attr("stroke-width", 2))

  drawingSet.push(drawHorizontalCutoffLine(columnStart * scale, 0, columnWidth * scale, paper).attr("stroke-width", 2))

  // width label
  let x1 = 0
  let y1 = footingHeight * scale + 12 
  let x2 = footingWidth * scale 
  let y2 = y1
  drawingSet.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  let str = `${footingWidth} in`  
  drawingSet.push(drawLabelForHorizontalDimension(str, x1, x2, y1, 12, paper))

  // thickness label
  x1 = -10
  y1 = (footingHeight - footingThickness) * scale
  x2 = x1
  y2 = y1 + footingThickness * scale  
  drawingSet.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${footingThickness} in`  
  drawingSet.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'left', 12, paper))

}

function drawTopViewColumnToEdgeDimensions(footing, scale, paper, drawingSet) {
  const footingWidth = footing.geometry.footingWidth
  const footingHeight = footing.geometry.footingWidth
  const columnWidth = footing.geometry.columnWidth
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5
  
  drawingSet.push(paper.rect(columnStart * scale, columnStart * scale, columnWidth * scale, columnWidth * scale).attr("stroke-width", 2))

  let x1 = (columnStart + columnWidth) * scale
  let y1 = footingHeight * 0.5 * scale
  let x2 = footingWidth * scale
  let y2 = y1
  drawingSet.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  let str = `${columnStart} in`  
  drawingSet.push(drawLabelForHorizontalDimension(str, x1, x2, y1, 12, paper))

  x1 = (footingHeight * 0.5) * scale
  y1 = 0
  x2 = x1
  y2 = columnStart * scale
  drawingSet.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${columnStart} in`  
  drawingSet.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'center', 12, paper))

}

function drawSideViewFloorAndFill(footing, scale, paper, drawingSet) {
  const footingWidth = footing.geometry.footingWidth
  const footingThickness = footing.geometry.footingThickness
  const footingHeight = footingWidth
  const columnWidth = footing.geometry.columnWidth
  const columnHeight = footingHeight - footingThickness
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5

  // fill line and dimension label
  if(footing.load.fillDepth > 0) {
    let h = columnHeight - footing.load.fillDepth
    if(h < 0) {
      h = columnHeight - footing.load.fillDepth - footing.load.floorSlabThickness
    }
    let x1 = -20
    let y1 = h * scale
    let x2 = columnStart * scale
    let y2 = y1
    let pathStr = pathM( x1, y1)
    pathStr += pathL( x2, y1)
    let p = paper.path(pathStr)
    p.attr("stroke-width", 1)
    //p.attr("stroke-dasharray", ["-"])
    drawingSet.push(p)

    x1 = (columnStart + columnWidth) * scale
    y1 = h * scale
    x2 = footingWidth * scale + 20
    y2 = y1
    pathStr = pathM( x1, y1)
    pathStr += pathL( x2, y1)
    p = paper.path(pathStr)
    p.attr("stroke-width", 1)
    //p.attr("stroke-dasharray", ["-"])
    drawingSet.push(p)

    x1 = -10
    y1 = h * scale
    x2 = x1
    y2 = columnHeight * scale
    let str = `${footing.load.fillDepth} in`  

    drawingSet.push(drawDiameterArrow(x1, y1, 10, paper))
    drawingSet.push(drawLabelForDiameterDimension(str, x1, y1, 10, 12, paper))
  }

  // floor slab
  if(footing.load.floorSlabThickness > 0) {
    let h = columnHeight - footing.load.fillDepth - footing.load.floorSlabThickness
    if(h < 0) {
      h = columnHeight
    }

    let x1 = -20
    let y1 = h * scale
    let x2 = columnStart * scale - 4
    let y2 = y1

    let pathStr = pathM( x1, y1)
    pathStr += pathL( x2, y1)
    pathStr += pathL(x2, y2 + footing.load.floorSlabThickness * scale)
    let p = paper.path(pathStr)
    p.attr("stroke-width", 1)
    //p.attr("stroke-dasharray", ["-"])
    drawingSet.push(p)

    x1 = (columnStart + columnWidth) * scale + 4
    y1 = h * scale
    x2 = footingWidth * scale + 20
    y2 = y1

    pathStr = pathM( x1, y1 + footing.load.floorSlabThickness * scale)
    pathStr += pathL( x1, y1)
    pathStr += pathL(x2, y2)
    p = paper.path(pathStr)
    p.attr("stroke-width", 1)
    //p.attr("stroke-dasharray", ["-"])
    drawingSet.push(p)

    x1 = footingWidth * scale
    y1 = h * scale
    x2 = x1
    y2 = (columnHeight - footing.load.fillDepth) * scale
    let str = `${footing.load.floorSlabThickness} in`  
    
    drawingSet.push(drawDiameterArrow(x1 - 14, y1, 10, paper))
    drawingSet.push(drawLabelForDiameterDimension(str, x1 - 14, y1, 10, 12, paper))
  }
}

function drawSideViewSteel(footing, scale, paper, drawingSet) {
  const footingWidth = footing.geometry.footingWidth
  const footingThickness = footing.geometry.footingThickness
  const footingHeight = footingWidth
  const columnWidth = footing.geometry.columnWidth
  const columnHeight = footingHeight - footingThickness
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5
  const cover = footing.footingConditions.cover

  // draw orthogonal steel line
  let x1 = cover 
  let y1 = footingHeight - cover
  let x2 = footingWidth - cover
  let y2 = y1 

  let barDiameter = footing.getRebarProperties().d
  let pathStr = pathM(x1 * scale, y1 * scale)
  pathStr += pathL(x2 * scale, y2 * scale)
  let p = paper.path(pathStr)
  p.attr("stroke-width", barDiameter * scale)
  drawingSet.push(p)

  // now draw rebar circles
  let d = x2 - x1
  
  y1 -= barDiameter
  let nBars = Math.floor(d / footing.steel.rebarSpacing)
  let delta = d / nBars
  for(let i = 0; i <= nBars; i++) {
    // draw circle at i * delta
    let offset = 0
    if(i === 0) { 
      offset = barDiameter
    } else if(i === nBars) {
      offset = -barDiameter
    }
    
    let c = paper.circle(
      (offset + x1 + i * delta) * scale,
      y1 * scale,
      barDiameter * 0.5 * scale)
      c.attr("stroke-width", 2),
    drawingSet.push(c)
  }
  
}

function drawOneWayShearArea(footing, scale, paper, drawingSet) {
  const footingWidth = footing.geometry.footingWidth
  const footingHeight = footing.geometry.footingWidth
  const columnWidth = footing.geometry.columnWidth
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5
  const h = footing.geometry.footingThickness
  const b_w = footing.geometry.footingWidth
  const d_b = footing.getRebarProperties().d
  const cover = 3 // how much concrete covers the rebar (inches)
  const d_avg = ((h - cover - d_b / 2) + (h - cover - d_b - d_b / 2)) / 2
  const onewayTributaryLength = b_w / 2 - columnWidth / 2 - d_avg
  

  // draw vertical dashed line at d_avg from edge of column
  let x1 = (b_w * 0.5 + columnWidth * 0.5 + d_avg) * scale
  let y1 = 0
  let x2 = x1
  let y2 = b_w * scale

  let pathStr = pathM( x1, y1)
  pathStr += pathL(x2, y2)
  let p = paper.path(pathStr)
  p.attr("stroke-width", 1)
  p.attr("stroke-dasharray", ["-"])
  drawingSet.push(p)

  // draw column vertical line for dimension
  x1 = (b_w * 0.5 + columnWidth * 0.5) * scale
  y1 = (b_w * 0.5 + columnWidth * 0.5) * scale + 4
  x2 = x1
  y2 = footingHeight * scale

  pathStr = pathM( x1, y1)
  pathStr += pathL(x2, y2)
  p = paper.path(pathStr)
  p.attr("stroke-width", 1)
  drawingSet.push(p)


  // draw d dimension
  x1 = (b_w * 0.5 + columnWidth * 0.5) * scale
  y1 = (footingHeight) * scale - 30
  x2 = (b_w * 0.5 + columnWidth * 0.5 + d_avg) * scale
  y2 = y1
  drawingSet.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  let str = `${Math.round(d_avg)} in`  
  drawingSet.push(drawLabelForHorizontalDimension(str, x1, x2, y1 + 12, 12, paper))

  // draw shear area length dimension
  x1 = (b_w * 0.5 + columnWidth * 0.5 + d_avg) * scale
  y1 = (footingHeight) * scale - 30
  x2 = (b_w) * scale
  y2 = y1
  drawingSet.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${Math.round(onewayTributaryLength)} in`  
  drawingSet.push(drawLabelForHorizontalDimension(str, x1, x2, y1 + 12, 12, paper))

  // draw callout for critical section
  x1 = (b_w * 0.5 + columnWidth * 0.5 + d_avg) * scale
  y1 = 30
  drawingSet.push(drawLeftCalloutArrow(x1, y1, 10, paper))
  drawingSet.push(drawLabelForLeftCallout('Critical Section', x1, y1, 10, 12, paper))

  // draw callout for critical area
  x1 = (b_w * 0.5 + columnWidth * 0.5 + d_avg) * scale + 10
  y1 = 70
  drawingSet.push(drawLeftCalloutArrow(x1, y1, 15, paper))
  drawingSet.push(drawLabelForLeftCallout('Tributary Area', x1, y1, 15, 12, paper))

}

function drawTwoWayShearArea(footing, scale, paper, drawingSet) {
  const footingWidth = footing.geometry.footingWidth
  const footingHeight = footing.geometry.footingWidth
  const columnWidth = footing.geometry.columnWidth
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5
  const h = footing.geometry.footingThickness
  const b_w = footing.geometry.footingWidth
  const d_b = footing.getRebarProperties().d
  const cover = 3 // how much concrete covers the rebar (inches)
  const d_avg = ((h - cover - d_b / 2) + (h - cover - d_b - d_b / 2)) / 2
  const onewayTributaryLength = b_w / 2 - columnWidth / 2 - d_avg
  const criticalPerimeterSideLength = d_avg + columnWidth
  

  // draw critical area perimeter
  let x = (columnStart - d_avg * 0.5) * scale
  let y = (columnStart - d_avg * 0.5) * scale
  
  let pathStr = pathM( x, y)
  pathStr += pathL(x, y + criticalPerimeterSideLength * scale)
  pathStr += pathL(x + criticalPerimeterSideLength * scale, y + criticalPerimeterSideLength * scale)
  pathStr += pathL(x + criticalPerimeterSideLength * scale, y)
  pathStr += pathL(x, y)
  let p = paper.path(pathStr)
  p.attr("stroke-width", 1)
  p.attr("stroke-dasharray", ["-"])
  drawingSet.push(p)

  // draw callout for critical section
  x = (columnStart + columnWidth) * scale
  drawingSet.push(drawLeftCalloutArrow(x, y, 10, paper))
  drawingSet.push(drawLabelForLeftCallout('Critical Shear Perimeter', x, y, 10, 12, paper))

  // draw label for tributary area
  drawingSet.push(drawLabelForHorizontalDimension('Tributary Area', 0, footingWidth * scale, 20, 12, paper))

  // draw dimension and label for critical section length
  x = (columnStart - d_avg * 0.5 + criticalPerimeterSideLength) * scale + 10
  y = (columnStart - d_avg * 0.5) * scale
  const x2 = x
  const y2 = y + criticalPerimeterSideLength * scale 
  let str = `${Math.round(criticalPerimeterSideLength)} in`  
  drawingSet.push(drawVerticalDoubleArrow(x, y, x2, y2, 10, paper))
  drawingSet.push(drawLabelForVerticalDimension(str, x, y, y2, 'right', 12, paper))
}

function drawFlexureArea(footing, scale, paper, drawingSet) {
  const footingWidth = footing.geometry.footingWidth
  const footingHeight = footing.geometry.footingWidth
  const columnWidth = footing.geometry.columnWidth
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5
  const h = footing.geometry.footingThickness
  const b_w = footing.geometry.footingWidth
  const d_b = footing.getRebarProperties().d
  const cover = 3 // how much concrete covers the rebar (inches)
  const d_avg = ((h - cover - d_b / 2) + (h - cover - d_b - d_b / 2)) / 2
  const onewayTributaryLength = b_w / 2 - columnWidth / 2 - d_avg
  

  // draw vertical dashed line at d_avg from edge of column
  let x1 = (b_w * 0.5 + columnWidth * 0.5) * scale
  let y1 = 0
  let x2 = x1
  let y2 = b_w * scale

  let pathStr = pathM( x1, y1)
  pathStr += pathL(x2, y2)
  let p = paper.path(pathStr)
  p.attr("stroke-width", 1)
  p.attr("stroke-dasharray", ["-"])
  drawingSet.push(p)

  // draw (b_w - column width) / 2 dimension
  x1 = (b_w * 0.5 + columnWidth * 0.5) * scale
  y1 = (footingHeight) * scale - 30
  x2 = b_w * scale
  y2 = y1
  drawingSet.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  let str = `${Math.round(b_w * 0.5 - columnWidth * 0.5)} in`  
  drawingSet.push(drawLabelForHorizontalDimension(str, x1, x2, y1 + 12, 12, paper))

  
  // draw callout for critical section
  //x1 = (b_w * 0.5 + columnWidth * 0.5 + d_avg) * scale
  y1 = 30
  drawingSet.push(drawLeftCalloutArrow(x1, y1, 10, paper))
  drawingSet.push(drawLabelForLeftCallout('Critical Section', x1, y1, 10, 12, paper))

  // draw callout for critical area
  x1 = x1 + 10
  y1 = 70
  drawingSet.push(drawLeftCalloutArrow(x1, y1, 15, paper))
  drawingSet.push(drawLabelForLeftCallout('Tributary Area', x1, y1, 15, 12, paper))

}

function drawSideViewShearCone(footing, scale, paper, drawingSet) {

  const footingWidth = footing.geometry.footingWidth
  const footingHeight = footing.geometry.footingWidth
  const columnWidth = footing.geometry.columnWidth
  const columnStart = footingWidth * 0.5 - columnWidth * 0.5
  const footingThickness = footing.geometry.footingThickness
  const h = footing.geometry.footingThickness
  const b_w = footing.geometry.footingWidth
  const d_b = footing.getRebarProperties().d
  const cover = 3 // how much concrete covers the rebar (inches)
  const d_avg = ((h - cover - d_b / 2) + (h - cover - d_b - d_b / 2)) / 2
  //const onewayTributaryLength = b_w / 2 - columnWidth / 2 - d_avg
  
  let edgeToColumn = footingWidth * 0.5 - columnWidth * 0.5
  // if dy is bigger than footing thickness then we have to figure out 
  // what the bottom length is based on 1/2 slope and y intercept at -thickness

  let slope = -1/2
  let dx1 = edgeToColumn
  let dy2 = -footingThickness
  let dx2 = dy2 / slope

  let dx = Math.min(dx1, dx2)

  //use the smaller of the two for the area calculation

  let x1 = (columnStart + columnWidth) * scale
  let y1 = (footingHeight - footingThickness) * scale
  let x2 = (columnStart + columnWidth + dx) * scale
  let y2 = (footingHeight - footingThickness - slope * dx) * scale

  let pathStr = pathM( x1, y1)
  pathStr += pathL(x2, y2)
  let p = paper.path(pathStr)
  p.attr("stroke-width", 1)
  p.attr("stroke-dasharray", ["-"])
  drawingSet.push(p)

  x1 = (columnStart) * scale
  y1 = (footingHeight - footingThickness) * scale
  x2 = (columnStart - dx) * scale
  y2 = (footingHeight - footingThickness - slope * dx) * scale

  pathStr = pathM( x1, y1)
  pathStr += pathL(x2, y2)
  p = paper.path(pathStr)
  p.attr("stroke-width", 1)
  p.attr("stroke-dasharray", ["-"])
  drawingSet.push(p)

  x1 = (columnStart - dx) * scale
  y1 = (footingHeight - footingThickness - slope * dx) * scale
  x2 = (columnStart + columnWidth + dx) * scale
  y2 = (footingHeight - footingThickness - slope * dx) * scale

  pathStr = pathM( x1, y1)
  pathStr += pathL(x2, y2)
  p = paper.path(pathStr)
  p.attr("stroke-width", 1)
  p.attr("stroke-dasharray", ["-"])
  drawingSet.push(p)

  // show A1 label
  x1 = (columnStart + columnWidth * 0.25) * scale
  y1 = (footingHeight - footingThickness) * scale
  drawingSet.push(drawLeftCalloutArrow(x1, y1, 10, paper))
  drawingSet.push(drawLabelForLeftCallout('A1', x1, y1, 10, 12, paper))

  // A2 label
  x1 = (columnStart + columnWidth) * scale
  y1 = (footingHeight - footingThickness - slope * dx) * scale
  drawingSet.push(drawLeftCalloutArrow(x1, y1, 5, paper))
  drawingSet.push(drawLabelForLeftCallout('A2', x1, y1, 5, 12, paper))


}

function getScale(modelWidth, modelHeight, paperRect) {
  const anchorBlockWidth = modelWidth //200
  const anchorBlockHeight = modelHeight //200

  // we want the model to fit in the canvas. we scale it so that it is 
  // either x% the width or x% the height depending on the aspect ratio
  // if w > h -> aspect w/h > 1.0 fit the model to the height
  // if w < h -> aspect w/h < 1.0 fit the model to the width

  const paperAspect = paperRect[0] / paperRect[1]
  const modelAspect = anchorBlockWidth / anchorBlockHeight

  if(paperAspect > 1.0 && modelAspect > 1.0) { return paperRect[0] / anchorBlockWidth * 0.80 }
  if(paperAspect < 1.0 && modelAspect > 1.0) { return paperRect[0] / anchorBlockWidth * 0.80 }
  if(paperAspect > 1.0 && modelAspect < 1.0) { return paperRect[1] / anchorBlockHeight * 0.80 }
  if(paperAspect < 1.0 && modelAspect < 1.0) { return paperRect[1] / anchorBlockHeight * 0.80 }
  return paperAspect < 1.0 ? paperRect[0] / anchorBlockWidth * 0.80 : paperRect[1] / anchorBlockHeight * 0.80
}

function pathM( x, y ) {return " M " + x + " " + y + " "; }

function pathL( x, y ) {return " L " + x + " " + y + " "; }

function drawHorizontalCutoffLine(x1, y1, length, paper) {
  let l = length
  let delta = 6
  
  let pathStr = pathM( x1, y1)
  pathStr += pathL( x1 + l * 0.5 - 2 * delta, y1)
  pathStr += pathL( x1 + l * 0.5 - delta, y1 + delta)
  pathStr += pathL( x1 + l * 0.5 + delta, y1 - delta)
  pathStr += pathL( x1 + l * 0.5 + 2 * delta, y1)
  pathStr += pathL( x1 + l, y1)
  let p = paper.path(pathStr)
  return p;
}

function drawHorizontalDoubleArrow(x1, y1, x2, y2, headSize, paper) {
    var halfTick = parseInt( headSize * 0.5 );
    var quarterTick = parseInt( headSize * 0.25 );
    var pathStr = pathM( x1 + halfTick, y1 - quarterTick );
    pathStr += pathL( x1, y1 );
    pathStr += pathL( x1 + halfTick, y1 + quarterTick);
    pathStr += pathM(x1, y1);
    pathStr += pathL(x2, y2);
    pathStr += pathL(x2 - halfTick, y2 - quarterTick);
    pathStr += pathM(x2, y2);
    pathStr += pathL(x2 - halfTick, y2 + quarterTick);
    var p = paper.path(pathStr);
    return p;
}

function drawVerticalDoubleArrow(x1, y1, x2, y2, headSize, paper) {
  var halfTick = parseInt( headSize * 0.5 );
  var quarterTick = parseInt( headSize * 0.25 );
  var pathStr = pathM( x1 - quarterTick, y1 + halfTick );
  pathStr += pathL( x1, y1 );
  pathStr += pathL( x1 + quarterTick, y1 + halfTick);
  pathStr += pathM(x1, y1);
  pathStr += pathL(x2, y2);
  pathStr += pathL(x2 - quarterTick, y2 - halfTick);
  pathStr += pathM(x2, y2);
  pathStr += pathL(x2 + quarterTick, y2 - halfTick);
  var p = paper.path(pathStr);
  return p;
}

function drawDownLoadArrow(x1, y1, x2, y2, headSize, paper) {
  let halfTick = parseInt( headSize * 0.5 );
  let quarterTick = parseInt( headSize * 0.25 );
  let pathStr = pathM(x1, y1);
  pathStr += pathL(x2, y2);
  pathStr += pathL(x2 - quarterTick, y2 - halfTick);
  pathStr += pathM(x2, y2);
  pathStr += pathL(x2 + quarterTick, y2 - halfTick);
  let p = paper.path(pathStr);
  return p;
}

function drawUpLoadArrow(x1, y1, x2, y2, headSize, paper) {
  let halfTick = parseInt( headSize * 0.5 );
  let quarterTick = parseInt( headSize * 0.25 );
  let pathStr = pathM( x1 - quarterTick, y1 + halfTick );
  pathStr += pathL( x1, y1 );
  pathStr += pathL( x1 + quarterTick, y1 + halfTick);
  pathStr += pathM(x1, y1);
  pathStr += pathL(x2, y2);
  let p = paper.path(pathStr);
  return p;
}

function drawDiameterArrow(x, y, size, paper) {
  let pathStr = pathM(x, y)
  pathStr += pathL(x + size, y - size * 2)
  pathStr += pathL(x + size + size, y - size * 2)
  return paper.path(pathStr)
}

function drawLeftCalloutArrow(x, y, size, paper) {
  let pathStr = pathM(x, y)
  pathStr += pathL(x - size, y - size * 2)
  pathStr += pathL(x - size - size, y - size * 2)
  return paper.path(pathStr)
}

function renderedTextBoundingBox(string, fontSize) {
  var paper = Raphael(0, 0, 0, 0);
  paper.canvas.style.visibility = 'hidden';

  var el = paper.text(0, 0, string);
  el.attr('font-size', fontSize);

  var bBox = el.getBBox();
  paper.remove();

  return {
      width: bBox.width,
      height: bBox.height
  };
}

function drawLabelForHorizontalDimension(textStr, x1, x2, y, fontSize, paper) {
  const textBBox = renderedTextBoundingBox(textStr, fontSize) 
  const st = paper.set()
  const xMid = Math.abs(x2 - x1) * 0.5
  const xStart = x1 + xMid
  let yStart = y
  if(textBBox.width > x2 - x1 - 20) {
    yStart += fontSize
  }
  const r = paper.rect(xStart - textBBox.width * 0.5 - 2, yStart, textBBox.width + 4, textBBox.height)
  r.attr("fill", "#ffffff")
  r.attr("stroke", "#ffffff")
  st.push(r)
  const l = paper.text(xStart, yStart, textStr);
  l.attr("font-size", fontSize)
  st.push(l)
  return st
}

function drawLabelForVerticalDimension(textStr, x, y1, y2, sideOfLine, fontSize, paper) {
  const textBBox = renderedTextBoundingBox(textStr, fontSize)
  const st = paper.set()
  const yMid = Math.abs(y2 - y1) * 0.5
  let xOffset = 0
  if(sideOfLine === 'left') {
    xOffset = -textBBox.width * 0.5 - 4
  } else if(sideOfLine ==='right') {
    xOffset = textBBox.width * 0.5 + 4
  }
  let xStart = x + xOffset 
  let yStart = y1 + yMid - fontSize * 0.5
  const r = paper.rect(xStart - textBBox.width * 0.5 - 2, yStart, textBBox.width + 4, textBBox.height)
  r.attr("fill", "#ffffff")
  r.attr("stroke", "#ffffff")
  st.push(r)
  const l = paper.text(xStart, y1 + yMid, textStr);
  l.attr("font-size", fontSize)
  st.push(l)
  return st
}

function drawLabelForDiameterDimension(textStr, x, y, dimSize, fontSize, paper) {
  const textBBox = renderedTextBoundingBox(textStr, fontSize)
  const x1 = x + dimSize + dimSize + 4 + textBBox.width * 0.5
  const y1 = y - dimSize * 2
  const l = paper.text(x1, y1, textStr);
  l.attr("font-size", fontSize)
  return l
}

function drawLabelForLeftCallout(textStr, x, y, dimSize, fontSize, paper) {
  const textBBox = renderedTextBoundingBox(textStr, fontSize)
  //const st = paper.set()
  //const yMid = Math.abs(y2 - y1) * 0.5
  let xOffset = textBBox.width * 0.5 + 4

  const x1 = x - dimSize - dimSize - xOffset
  const y1 = y - dimSize * 2
  const l = paper.text(x1, y1, textStr);
  l.attr("font-size", fontSize)
  return l
}


/*// draw the footing -- keep here for eventual wall / strip footing support
  // if wall footing draw cut off lines, otherwise it's just a square
  if(isColumnFooting) {
    st.push(paper.rect(0, 0, footingWidth * scale, footingHeight * scale).attr("stroke-width", 2))
  } else {
    let pathStr = pathM( 0, 0)
    pathStr += pathL( 0, footingHeight * scale)
    let p = paper.path(pathStr)
    st.push(p.attr("stroke-width", 2))
  
    pathStr = pathM( footingWidth * scale, 0)
    pathStr += pathL( footingWidth * scale, footingHeight * scale)
    p = paper.path(pathStr)
    st.push(p.attr("stroke-width", 2))

    st.push(drawHorizontalCutoffLine(0, 0, footingWidth * scale, paper).attr("stroke-width", 2))
    st.push(drawHorizontalCutoffLine(0, footingHeight * scale, footingWidth * scale, paper).attr("stroke-width", 2))
  } 
  
  if(isColumnFooting) {
    st.push(paper.rect(columnStart * scale, columnStart * scale, columnWidth * scale, columnWidth * scale).attr("stroke-width", 2))
  } else {
    let pathStr = pathM(columnStart * scale, 0)
    pathStr += pathL(columnStart * scale, footingHeight * scale)
    let p = paper.path(pathStr)
    st.push(p.attr("stroke-width", 2))
  
    const wallEnd = footingWidth * 0.5 + columnWidth * 0.5
    pathStr = pathM( wallEnd * scale, 0)
    pathStr += pathL( wallEnd * scale, footingHeight * scale)
    p = paper.path(pathStr)
    st.push(p.attr("stroke-width", 2))
  }
  */
